import { defaultDictionaryValueMissing } from '../repository';

export type JobKey = 'JobAgentHeading' | 'JobListNavigationHeading' | 'UnsolicitedApplicationLinkText' | 'JobListNoDeadlineText';

export const getDefaultJobValue = (key: JobKey): string => {
	switch (key) {
		case 'JobListNavigationHeading':
			return 'Muligheder';
		case 'JobAgentHeading':
			return 'Opret jobagent';
		case 'UnsolicitedApplicationLinkText':
			return 'Uopfordret ansøgning';
		case 'JobListNoDeadlineText':
			return 'Løbende';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
